import { render, staticRenderFns } from "./MyPrivacy.vue?vue&type=template&id=e51c0126&scoped=true"
import script from "./MyPrivacy.vue?vue&type=script&lang=js"
export * from "./MyPrivacy.vue?vue&type=script&lang=js"
import style0 from "./MyPrivacy.vue?vue&type=style&index=0&id=e51c0126&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51c0126",
  null
  
)

export default component.exports